import {useMutation, useQueryClient} from 'react-query';
import {useTranslation} from 'react-i18next';

import api from 'utils/api';
import {setAlert, setSuccessAlert} from 'actions/alerts';
import contentKeys from 'actions/content/queryKeys';

import playlistKeys from './queryKeys';

function useDeletePlaylistContent(
	playlistId,
	{successMessage, errorMessage} = {}
) {
	const {t} = useTranslation();
	const queryClient = useQueryClient();

	async function deletePlaylistContent(contentId) {
		return api(
			'delete',
			`/api/playlists/${playlistId}/contents/${contentId}`
		);
	}

	const {isLoading, isError, mutateAsync} = useMutation(
		deletePlaylistContent,
		{
			onSuccess: () => {
				// Invalidate all the playlist queries – this makes sure
				// that asset counts in list views are up-to-date
				queryClient.invalidateQueries(playlistKeys.allPlaylists);
				queryClient.invalidateQueries(contentKeys.contentLogs());
				setSuccessAlert({
					title:
						successMessage ||
						t('alert_playlist_updated_successfully'),
				});
			},
			onError: () => {
				setAlert({
					title: errorMessage || t('alert_playlist_not_updated'),
				});
			},
		}
	);

	return {isLoading, isError, deletePlaylistContent: mutateAsync};
}

export default useDeletePlaylistContent;
